// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2bZgs","tabsBox":"styles_tabsBox__17OJd","createButton":"styles_createButton__12f62"};